import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

interface UpdateResolution886ReviewReportParams {
	organization_id: string;
	company_id: string;
	report_id: string;
	review_id: string;
	step: number;
}

const Service = Resolution886ReportService.getInstance();

export const useUpdateStepResolution886Report = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: UpdateResolution886ReviewReportParams) => Service.updateStep(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_RESOLUTION_886_REPORT_REVIEW]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_RESOLUTION_886]);
		}
	});
};
